import {clickEvent} from "../../../webpack/modules/events";
import {createModalFromHtml, showModal} from "../../../webpack/modules-optimized/modal";
import {hideImageSliderLoader, showImageSliderLoader} from "../../../webpack/modules-optimized/product-page-ui";
import {post} from "../../../webpack/modules/ajax";

let arToolReady = false;
clickEvent('#product-page .open-ar-tool', false, async function(element) {
    if (arToolReady) {
        showModal('ar-modal');
        return;
    }

    let productId = element.closest('#product-page').dataset.productId;

    showImageSliderLoader();
    await loadModal(productId);
    await loadModelViewerScript();
    await import(/* webpackChunkName: "product-page-ar-tool" */ './main');
    showModal('ar-modal');
    hideImageSliderLoader();
    arToolReady = true;
});

function loadModal(productId)
{
    return new Promise(resolve => {
        post(
            '/ajax/website/product/get-ar-tool-modal',
            {
                productId: productId,
            },
            function (response) {
                createModalFromHtml(response.modal);
                resolve();
            },
        );
    });
}

function loadModelViewerScript()
{
    return new Promise(resolve => {
        let script = document.createElement('script');

        script.type = 'module';
        script.src = 'https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js';
        document.head.appendChild(script);

        script.onload = function () {
            resolve();
        };
    });
}